export const pathOPCDashboard = 'dashboard-opc';
export const pathOPCList = 'list-opc';
export const pathOPCAnalytics = 'analytics-opc';
export const pathOPCMaxPrice = 'max-price-opc';
